import { render, staticRenderFns } from "./PayView.vue?vue&type=template&id=5bc9d533"
import script from "./PayView.vue?vue&type=script&lang=js"
export * from "./PayView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports